import {post} from "../utils";

export default ({url}) => post(`${url}`)
  .then(result => result.json())